import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';


ReactDOM.render(
  <React.StrictMode>
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Train+One&display=swap');
      @import url('https://fonts.googleapis.com/css2?family=Syne+Mono&display=swap');
    </style>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


